import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ApiKeyState } from './api-key.reducer';

export const getApiKeyState = createFeatureSelector<ApiKeyState>('apiKey');

export const getApiKeys = createSelector(getApiKeyState, (state: ApiKeyState) =>
  state.ids.map((id) => state.entities[id]),
);

export const getApiKey = (id: number) =>
  createSelector(getApiKeyState, (state: ApiKeyState) => state.entities[id]);

export const getApiKeysLoaded = createSelector(
  getApiKeyState,
  (state: ApiKeyState) => state.loaded,
);

export const getApiKeysError = createSelector(
  getApiKeyState,
  (state: ApiKeyState) => state.apiError,
);

export const getApiKeysSort = createSelector(getApiKeyState, (state: ApiKeyState) => state.sort);
